import React from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../../components/ContentfulImage';
import {
  CloseIcon,
  ContentWrapper,
  PlusIcon,
  ImageList,
  Item,
  TextLabel,
  ToggleButton,
  MinusIcon,
  Wrapper,
} from './ImageSlider.style';

class ImageSlider extends React.Component {
  state = {
    isOpen: false,
  };

  toggleOpen = () => {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  };

  render() {
    const { itemList, buttonText } = this.props;
    const { isOpen } = this.state;
    return (
      <Wrapper>
        <ToggleButton disabled={!itemList.length} isOpen={isOpen} onClick={this.toggleOpen}>
          <span />
          {buttonText}
          {isOpen ? <MinusIcon /> : <PlusIcon />}
        </ToggleButton>
        {isOpen && (
          <React.Fragment>
            <ContentWrapper>
              <CloseIcon onClick={this.toggleOpen} />
              <ImageList>
                {itemList.map(item => (
                  <Item key={item.title}>
                    <Image
                      src={item}
                      options={{
                        w: ['calc((100vw - 40px) * 0.41)', '200px'],
                        h: ['calc((100vw - 40px) * 0.41 * 0.75 + 3px)', '150px'],
                        boxShadow: '0px 2px 6.1px 0.9px rgba(0, 0, 0, 0.35)',
                      }}
                    />
                    <TextLabel>{item.title}</TextLabel>
                  </Item>
                ))}
              </ImageList>
            </ContentWrapper>
          </React.Fragment>
        )}
      </Wrapper>
    );
  }
}

ImageSlider.defaultProps = {
  itemList: [],
  buttonText: null,
};

ImageSlider.propTypes = {
  buttonText: PropTypes.string,
  itemList: PropTypes.arrayOf(PropTypes.object),
};

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/Common/ImageSlider/ImageSlider.js